import { render, staticRenderFns } from "./OrderDetailsContent.vue?vue&type=template&id=3c11b616&"
import script from "./OrderDetailsContent.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsContent.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsContent.vue?vue&type=style&index=0&id=3c11b616&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrderTracking: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/OrderTracking.vue').default})
